export default __webpack_public_path__ + "static/media/imagecutout_removebackground.f23d9a06.png";